import React, {useState} from 'react';
import axios from '../Common/axios';
import { Table, Modal, Spin } from "antd";
import {getGridTableHeight} from '../Common/util';
import {postModifyResultData} from '../Common/api';
import { SearchOutlined } from '@ant-design/icons';


/** -------------------------------------------------------------------------- **/
function Risk({riskDetailList, rowKey}) {

    // Table 선택박스 설정
    const [spinflag, setSpinflag] = useState(false);
    const titleName="위험 평가";
    const riskDetailColumn =[
        {
            title: '분류',
            dataIndex: 'measure_type',
            key: 'measure_type',
            width: '50px',
            align: 'left',
            ellipsis: false
        },
        // {
        //     title: '자산코드',
        //     dataIndex: 'asset_cd',
        //     key: 'asset_cd',
        //     width: '70px',
        //     align: 'left',
        //     ellipsis: false

        // },
        {
            title: '취약점ID',
            dataIndex: 'measure_cd',
            key: 'measure_cd',
            width: '80px',
            align: 'left',
            ellipsis: false,

        },
        {
            title: '취약점 항목',
            dataIndex: 'measure_nm',
            key: 'measure_nm',
            width: '200px',
            align: 'center',
            ellipsis: false,
        },
        // {
        //     title: '위험도',
        //     dataIndex: 'risk_score',
        //     key: 'risk_score',
        //     width: '80px',
        //     align: 'center',
        //     fixed: 'left',
        //     ellipsis: false,
        // },
        // {
        //     title: '위험점수',
        //     dataIndex: 'score_value',
        //     key: 'score_value',
        //     width: '40px',
        //     align: 'center',
        //     ellipsis: false,
        // },
        {
            title: '위협 항목',
            dataIndex: 'threat_nm',
            key: 'threat_nm',
            width: '250px',
            align: 'center',
            ellipsis: false,
        },
        {
            title: '위협 내용',
            dataIndex: 'threat_desc',
            key: 'threat_desc',
            width: '350px',
            align: 'center',
            ellipsis: false,
        },
        {
            title: '위험 시나리오',
            dataIndex: 'risks',
            key: 'risks',
            width: '300px',
            align: 'center',
            ellipsis: false,
        },
    ];
    //----------------------------------------------------------------------------------------
    return (
        <Spin size={"large"}  tip={"Loading..."} spinning={spinflag}>
            <div id="divTabs1" className="section" style={{height:getGridTableHeight(200), overflowY:'auto'}}>
                <div className="sub_title">
                        ■ {titleName}
                        {/* &nbsp;&nbsp;&nbsp;&nbsp;
                        <span style={{color:'#0378c7', fontSize:'11px', fontWeight:'normal'}}>※ [일괄적용]시 수정하고자 하는 항목에만 값을 입력해 주세요.</span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span style={{color:'#0378c7', fontSize:'11px', fontWeight:'normal'}}>※ <SearchOutlined />필터 적용 시, [저장]후 다음 작업 진행시 필터해제 후 진행해 주세요.</span> */}
                </div>
                <div style={{padding: '10px 10px'}}>
                <Table columns={riskDetailColumn}
                        dataSource={riskDetailList}
                        pagination={false}
                        rowKey='measure_cd'
                        bordered size={"small"}
                        className="sub_table"
                    >
                    </Table>
                </div>
            </div>
        </Spin>
    );
}
export default Risk;